{
  "wow": {
    "title": "wow",
    "description": "Gli strumenti della serie WOW prendono ispirazione dalla scuola di pensiero proveniente dal maestro Antonio Pioli detto Wandrè (Cavriago, Italia 1926-2004). Partendo dal meraviglioso modello “Blue Jeans” degli anni '60, la serie WOW è stata sviluppata e messa a punto tra il 2017 e il 2022. WOW è caratterizzata da un manico basculante in alluminio a sezione ovale. L'action è regolabile mediante una vite posta sul retro del corpo. Lo strumento è completamente disassemblabile e intercambiabile in ogni sua parte.",
    "dataSheet": {
      "Disponibili al pubblico": "SI",
      "Tecnologia Tarazum": "SI",
      "Progettazione Tarazum": "SI",
      "Disegno Tarazum": "SI",
      "Finiture Tarazum": "SI"
    },
    "guitars": [
      {
        "icarus": {
          "title": "icarus",
          "description": "La chitarra Tarazum WOW Icarus prosegue il percorso del precedente modello omonimo. La Icarus risulta più leggera di 200 grammi rispetto al precedente modello. La forma rimane sostanzialmente invariata ad eccezione del corno superiore maggiormente pronunciato per spostare il baricentro dello strumento e equilibrare l'ulteriore alleggerimento. Cambia radicalmente la costruzione: Icarus è un modello semihollow costruito con fondo, fasce e top in pioppo liscio. Il blocco interno centrale è stato lavorato con delle forature per permettere alle risonanze interne di correre lungo l'interno corpo dello strumento fino a due forature poste esattamente sotto i due pickup. In questo modo la parte di suono fisica può dare loro un reale supporto creando una timbrica ed un sustain unici.",
          "dataSheet": {
            "Serie": "WOW",
            "Anno": "2023",
            "Costruzione": "Semihollow, bolt on (manico avvitato)",
            "Manico": "alluminio sezione ovale",
            "Top": "pioppo liscio",
            "Fondo e fasce": "pioppo liscio",
            "Tastiera": "Padouk",
            "Capotasto": "alluminio",
            "Scala": "628,65 mm",
            "Radius": "10''",
            "Scalatura corde": "0.10-0.46",
            "Pickup bridge": "Duesenberg PH9NN SingleTwin Domino",
            "Pickup neck": "Duesenberg PH9NN SingleTwin Domino",
            "Bridge": "Tune 'o matic style con rialzo in wengè",
            "Regolazioni": "1 ton (250k log + cond. carta/olio 0,033 uF), 1 vol (250k log), switch 3 vie",
            "Meccaniche": "Fender Machine Heads SL-CHR",
            "Tailpiece": "Artigianale in alluminio e acciaio armonico",
            "Peso": "2,3 kg",
            "Finitura body": "Colore curcuma sovratinta anilina rame + vernice poliresinosa all'alcool",
            "Finitura manico": "Alluminio lucidatura a specchio",
            "Status": "disponibile"
          }
        }
      },
      {
        "klein": {
          "title": "klein",
          "description": "La chitarra Tarazum WOW è uno strumento unico nel suo genere. Ispirato alle modalità costruttive del maestro Wandrè, questo strumento elimina la barra truss-rod di rinforzo per un unico elemento portante in alluminio a sezione ovale. La sua cavità funge essa stessa da cassa di risonanza insieme alle camere tonali del body. Quest'ultimo è concepito come un elemento unitario e plastico. Tutta la sezione elettronica è concentrata in un unico corpo in alluminio smontabile e sostituibile anche a corde montate. Con uno spessore di 25 mm ed un peso di soli 2,3kg. questo strumento porta all'essenziale il concetto di chitarra elettrica. Suonare per credere!",
          "dataSheet": {
            "Serie": "WOW",
            "Anno": "2022",
            "Costruzione": "bolt on – body con camere tonali",
            "Manico": "alluminio sezione ovale",
            "Body": "pioppo liscio + top in pioppo marezzato",
            "Tastiera": "ovangkol",
            "Capotasto": "alluminio",
            "Scala": "24,75''",
            "Radius": "10''",
            "Scalatura corde": "0.10-0.46",
            "Pickup bridge": "Goldo P90 Silverfoil",
            "Pickup neck": "Goldo P90 Silverfoil",
            "Bridge": "Höfner H72/20-N Bridge",
            "Regolazioni": {
              "Tono": "1 tono (250k log + condensatore carta/olio 0,033 uF)",
              "Volume": "1 volume (250k log)"
            },
            "Meccaniche": "Fender Machine Heads SL-CHR",
            "Tailpiece": "Artigianale in alluminio e acciaio armonico",
            "Peso": "2,3 kg",
            "Finitura body": "Coloritura con anilina Blu Klein + vernice di finitura trasparente all'alcool",
            "Finitura manico": "lucidatura a specchio",
            "Status": "disponibile"
          }
        }
      }
    ]
  },
  "slurp": {
    "title": "slurp",
    "description": "Gli strumenti della serie SLURP sono caratterizzati da una costruzione tradizionale dello strumento unito ad un lavoro di progettazione e design ad hoc. Ogni strumento ha una sua precisa specificità ed è stato creato con un concept chiaro e mirato. La lavorazione in resina della tastiera rappresenta uno dei punti di riconoscibilità del marchio Tarazum ed e garantisce un alto grado di personalizzazione e customizzazione sulla base dell'esigenza e gusto di ogni singolo musicista.",
    "dataSheet": {
      "Disponibili al pubblico": "SI",
      "Tecnologia Tarazum": "NO",
      "Progettazione Tarazum": "SI",
      "Disegno Tarazum": "SI",
      "Finiture Tarazum": "SI"
    },
    "guitars": [
      {
        "volteggio": {
          "title": "volteggio",
          "description": "La chitarra Tarazum SLURP Volteggio è uno strumento solid body realizzato con due masselli in frassino marezzato a fibra lineare. Prima dell'incollaggio sul profilo delle due tavole sono state praticate delle camere tonali orizzontali su tutta la lunghezza del body. I diametri e la distanza dei fori sono in rapporto armonico relativamente al diapason dello strumento. Questa caratteristica, oltre che alleggerire il peso, permette una risonanza delle armoniche naturali proprie della chitarra. Il modello SLURP Volteggio rappresenta anche la prima creazione Tarazum ad avere implementato un nuovo disegno di paletta. Questa unisce le migliori caratteristiche dei modelli stile Fender con quelli stile Gibson. Infatti la paletta con disegno originale Tarazum presenta una inclinazione di 17° per una pressione ottimale delle corde sul capotasto e contemporaneamente una disposizione delle meccaniche che permette di avere le corde dritte e parallele oltre il capotasto.",
          "dataSheet": {
            "Serie": "SLURP",
            "Anno": "2026",
            "Costruzione": "Manico incollato, camere tonali orizzontali",
            "Manico": "Black-limba",
            "Body": "Frassino marezzato (2 pezzi)",
            "Tastiera": "Ovangkol",
            "Scala": "643,78 mm",
            "Radius": "10''",
            "Bridge": "Tonerider HB-Sized P90 pickup – nickel",
            "Middle": "none",
            "Neck": "Tonerider HB-Sized P90 pickup – nickel",
            "Regolazioni": "1 ton (250k lin + cond. carta/olio 0,033 uF), 1 vol (250k lin), switch 3 vie",
            "Meccaniche": "Kluson M 33 JP",
            "Capotasto": "Corian",
            "Ponte": "Schaller roller bridge",
            "Fermacorde/tremolo": "Vibrato Bigsby b50",
            "Peso": "3,7 kg",
            "Scalatura corde": "0.10-0.52",
            "Finitura body": "vernice poliresinosa all'alcool",
            "Finitura manico": "vernice poliresinosa all'alcool",
            "Status": "disponibile"
          }
        }
      },
      {
        "miscellanea": {
          "title": "miscellanea",
          "description": "La chitarra Tarazum SLURP Miscellanea rappresenta l'idea costruttiva ideale di Tarazum relativamente ad uno strumento semi-hollow body. Infatti unisce un corpo cavo realizzato con un top sottile, fondo e fasce in pero marezzato con una costruzione neck-through. Questa combinazione è molto rara (con alta complessità costruttiva) e conferisce allo strumento un sustain unico. Il manico che prosegue nel corpo cavo senza soluzione di continuità permette alle vibrazioni di correre liberamente su tutta la lunghezza dello strumento e riverberare nelle ali cave. Tali cave sono collegate tra di loro da delle forature trasversali andando ad avvicinarsi all'idea di cassa armonica.",
          "dataSheet": {
            "Serie": "SLURP",
            "Anno": "2025",
            "Costruzione": "neck-through",
            "Manico": "Acero liscio",
            "Top/fondo/fasce": "Pero",
            "Tastiera": "Pero termotrattato",
            "Scala": "648mm",
            "Radius": "10''",
            "Bridge": "Tonerider Vintage 90 Cream",
            "Middle": "none",
            "Neck": "Tonerider Vintage 90 Cream",
            "Regolazioni": "1 ton (250k lin + cond. carta/olio 0,033 uF), 1 vol (250k lin), switch 3 vie",
            "Meccaniche": "Schertler 3+3",
            "Capotasto": "osso",
            "Ponte": "Tuffset bridge",
            "Fermacorde": "Custom in alluminio (produzione Tarazum)",
            "Peso": "3,4 kg",
            "Scalatura corde": "0.10-0.52",
            "Finitura body": "vernice poliresinosa all'alcool",
            "Finitura manico": "vernice poliresinosa all'alcool",
            "Status": "disponibile"
          }
        }
      },
      {
        "mono": {
          "title": "mono",
          "description": "Il basso Tarazum Mono è uno strumento sobrio ed elegante. E' pensato per avere il massimo della semplicità in termini di suonabilità e gestione complessiva dello strumento specialmente per la dimensione “live”. Con il peso di soli 3,1kg si attesta tra i bassi elettrici solid body più leggeri del mercato. La scelta dei materiali unita alla posizione e tipologia del pick-up conferisce allo strumento un timbro rotondo e nitido.",
          "dataSheet": {
            "Serie": "SLURP",
            "Anno": "2022",
            "Costruzione": "manico incollato",
            "Manico": "mogano",
            "Body": "frassino termotrattato",
            "Tastiera": "palissandro Santos",
            "Capotasto": "corozo",
            "Scala": "34''",
            "Radius": "10''",
            "Scalatura corde": "45-105 extra long scale",
            "Bridge": "Torozo bridge (Hofner style)",
            "Neck": "Hofner pickup H511-TAB",
            "Regolazioni": {
              "Tono": "1 tono (250k log + condensatore carta/olio 0,033 uF)",
              "Volume": "1 volume (250k log)"
            },
            "Meccaniche": "TK-7946 All parts",
            "Tailpiece": "Artigianale in ebano con piastra metallica integrata per messa a terra",
            "Peso": "3,1 kg",
            "Finitura body": "verniciatura trasparente all'alcool",
            "Finitura manico": "verniciatura trasparente all'alcool",
            "Status": "disponibile"
          }
        }
      },
      {
        "pinderbass": {
          "title": "pinderbass",
          "description": "Il basso Tarazum Pinderbass rappresenta un alter-ego del famoso basso Mucicman Stingray. Si tratta infatti di un basso attivo con humbuker in posizione centrale. I controlli di equalizzazione permettono l'ottimale gestione delle tre principali categorie di frequenze: basse, medie, alte. Il basso è molto maneggevole e possiede un incredibile output sonoro. Preciso al tocco e dal timbro cordoso e nitido si presta perfettamente per ottenere registrazioni audio di alta qualità.",
          "dataSheet": {
            "Serie": "SLURP",
            "Anno": "2017",
            "Costruzione": "manico avvitato",
            "Manico": "acero liscio",
            "Body": "frassino termotrattato",
            "Tastiera": "palissandro India",
            "Scala": "34''",
            "Radius": "piatto",
            "Bridge": "-",
            "Middle": "Seymour Duncan SMB-4A",
            "Neck": "-",
            "Regolazioni": {
              "Volume": "1 mater",
              "Toni": ["high", "mid", "low"]
            },
            "Finitura body": "gommalacca",
            "Finitura manico": "gommalacca",
            "Credits": "pictures by Ideo (www.ideo-lab.com)",
            "Status": "Sold"
          }
        }
      },
      {
        "felipe": {
          "title": "felipe",
          "description": "La chitarra Tarazum Felipe è caratterizzata da una costruzione neck thru body con ali in frassino termotrattato e corpo centrale in mogano. Questo strumento presenta delle cavità trasversali all'interno del body che fungono da camere tonali e alleggerimento del peso. Il progetto è stato sviluppato a partire dalle esigenze di Filippo Giovagnoni, proprietario dello strumento e chitarrista della band alternative rock No Pine Mall.",
          "dataSheet": {
            "Serie": "SLURP",
            "Anno": "2016",
            "Costruzione": "neck-trough",
            "Manico": "Mogano",
            "Body": "Mogano / Frassino",
            "Tastiera": "Palissandro India",
            "Scala": "24,75''",
            "Radius": "7,25''",
            "Bridge": "DiMarzio DP155BC The Tone Zone",
            "Middle": "none",
            "Neck": "Seymour Duncan SJM-3N",
            "Regolazioni": "2 volumi",
            "Finitura body": "gommalacca",
            "Finitura manico": "gommalacca"
          }
        }
      },
      {
        "spring": {
          "title": "spring",
          "description": "La chitarra Tarazum SLURP Spring è caratterizzata da un circuito elettronico molto speciale: oltre al classico switch a tre vie per la selezione del pick-up, presenta altri due switch che permettono di splittare i singoli avvolgimenti di ogni pickup (avvolti tre poli per volta). Questa caratteristica permette modalità di impostazione del suono dello strumento molto particolari. I chitarristi che amano la ricerca sonora mediante l'utilizzo di pedalini effetto potrebbero trovare nel modello SPRING un ottimo alleato. La chitarra ha finiture naturali che garantiscono il massimo in termini di risonanti e sustain. La stile è semplice e fresco come la primavera. I segna tasti in resina contengono una selezione di fiori primaverili essiccati tipici delle aree verdi presenti poco fuori dall'hinterland milanese.",
          "dataSheet": {
            "Serie": "SLURP",
            "Anno": "2024",
            "Costruzione": "manico incollato",
            "Manico": "mogano kaya",
            "Body": "Douglas",
            "Tastiera": "Palissandro",
            "Capotasto": "corian",
            "Scala": "631mm",
            "Radius": "14''",
            "Scalatura corde": "0.10-0.46",
            "Pickup bridge": "Duesenberg PH9NN SingleTwin Domino",
            "Pickup neck": "Duesenberg PH9NN SingleTwin Domino",
            "Bridge": "Schaller STM TOM-Style Bridge N",
            "Regolazioni": "1 tone (250k log + cond. carta/olio 0,033 uF), 1 vol (250k log), double switch",
            "Meccaniche": "Kluson M33JP Double Line Junior Nickel",
            "Tailpiece": "A trapezio in metallo (blocchetto in ebano)",
            "Peso": "3,4 kg",
            "Finitura body": "Cera d'api naturale",
            "Finitura manico": "Cera d'api naturale",
            "Status": "disponibile"
          }
        }
      }
    ]
  },
  "roar": {
    "title": "roar",
    "description": "Gli strumenti della serie ROAR consistono in repliche dei modelli di chitarre e bassi che hanno fatto la storia della musica degli ultimi cento anni. Tali modelli non sono “copie” bensì repliche modificate in temini di componentistica, costruzione e finiture sulla base delle esigenze dello specifico musicista.",
    "dataSheet": {
      "Disponibili al pubblico": "SI",
      "Tecnologia Tarazum": "NO",
      "Progettazione Tarazum": "NO",
      "Disegno Tarazum": "NO",
      "Finiture Tarazum": "SI"
    },
    "guitars": [
      {
        "lv": {
          "title": "lv",
          "description": "La chitarra Tarazum ROAR Lv riproduce fedelmente la costruzione del modello di chitarra classica di Torres. Il suono è molto bilanciato, caldo e profondo con una accentuazione sulle frequenze medio basse. La rosetta, i filetti e le altre decorazioni si basano sul gioco dissonante dei legni di Padouk e Amaranto che le regalano una estetica sobria ma univoca. I disegni della spalla mancante e della paletta sono stati realizzati da Tarazum sulla base dei rapporti aurei dello strumento ricondotti all'unità fondamentale del diapason.",
          "dataSheet": {
            "Serie": "ROAR",
            "Anno": "2026",
            "Costruzione": "Chitarra classica modello Torres",
            "Manico": "Mogano",
            "Tavola armonica": "Abete termotrattato",
            "Fondo e fasce": "Palissandro Santos",
            "Tastiera": "Ziricote",
            "Scala": "648 mm",
            "Radius": "piatto",
            "Bridge": "-",
            "Middle": "-",
            "Neck": "-",
            "Regolazioni": "-",
            "Meccaniche": "Schertler 3+3 classic pro",
            "Capotasto": "Osso",
            "Ponte": "Osso",
            "Fermacorde": "Ziricote",
            "Peso": "1,5 kg",
            "Scalatura corde": "Aquila ambra 2000",
            "Finitura body": "vernice poliresinosa all'alcool",
            "Finitura manico": "vernice poliresinosa all'alcool",
            "Status": "disponibile"
          }
        }
      },
      {
        "tretrecinque": {
          "title": "tretrecinque",
          "description": "La chitarra Tarazum TRETRECINQUE prende spunto dall'omonimo modello Gibson. Risulta uno strumento molto maneggevole e pesa quasi un chilo meno del modello Gibson originale grazie all'utlizzo del legno di pioppo. L'idea estetica dello strumento è quella di essere monocromatica. Non più i tradizionali contrasti chiaro-scuro tra finitura, binding e segnatasti: TRETRECINQUE presenta un binding nero sul colore marrone scuro e dei segnatasti in ABS nera sulla tastiera in ebano. Una chitarra quindi per mani esperte. I due potenziometri push-pull dei toni permettono di attivare o disattivare i singoli pickup eliminando in questo modo il selettore a tre vie previsto nel modello Gibson. Il suono risulta caldo e corposo, particolarmente adatto a suonare Jazz.",
          "dataSheet": {
            "Serie": "ROAR",
            "Anno": "2023",
            "Costruzione": "manico incollato - semihollow",
            "Manico": "mogano",
            "Body": "pioppo liscio + top in pioppo marezzato",
            "Tastiera": "ebano",
            "Capotasto": "osso",
            "Scala": "24,75''",
            "Radius": "10''",
            "Scalatura corde": "0.10-0.52",
            "Pickup bridge": "Tonerider Vintage 90 – Alnico II soapbar",
            "Pickup neck": "Tonerider Vintage 90 – Alnico II soapbar",
            "Bridge": "Tune 'o matic model",
            "Regolazioni": "2 toni on-off (250k log + cond. carta/olio 0,033 uF), 1 volume (250k log)",
            "Meccaniche": "Kluson M33VC Single Line Tulip",
            "Tailpiece": "A trapezio",
            "Peso": "3,2 kg",
            "Finitura body": "Coloritura con anilina marrone + vernice di finitura gommalacca",
            "Finitura manico": "Coloritura con anilina marrone + vernice di finitura gommalacca",
            "Status": "disponibile"
          }
        }
      },
      {
        "venere": {
          "title": "venere",
          "description": "Il modello Venere di Tarazum parte dall'idea di poter far confluire il meglio di due marchi iconici del mondo della chitarra elettrica: Fender e Gibson. “Venere” ha una veste Fender (mod.Jazzmaster) e un'anima Gibson (mod.Les Paul). Tutta la tecnologia costruttiva è ispirata a Gibson. In particolare: manico incollato al body per una migliore trasmissione delle vibrazioni; paletta inclinata per una migliore stabilità delle corde; body e manico in mogano per una maggiore leggerezza e morbidezza; manico inclinato e tune o'matic bridge (personale preferenza ai ponti montati da Fender). L'attitudine è invece Fender: tailpiece lungo con vibrato, body con camere tonali in stile “thin line” per una maggiore leggerezza e risonanza; formato del body nello stile unico del modello Jazzmaster. Suono caldo in stile Gibson e al contempo tagliente in stile Fender.",
          "dataSheet": {
            "Serie": "ROAR",
            "Anno": "2021",
            "Costruzione": "manico incollato",
            "Manico": "mogano Kaya",
            "Body": "mogano Kaya",
            "Tastiera": "ebano Makassar",
            "Capotasto": "osso",
            "Scala": "24,75''",
            "Radius": "12''",
            "Scalatura corde": "0.10-0.52",
            "Bridge": "Seymour Duncan bridge quarter pound JM-PU",
            "Neck": "Seymour Duncan neck quarter pound JM-PU",
            "Regolazioni": {
              "VOL": "1 pot 500k",
              "TON": "2 pot 250k push-pull (ON-OFF pickup)",
              "CONDENSATORI": "n°2 carta olio da 0,0033 uF"
            },
            "Finitura body": "vernice naturale all'alcool (poro aperto)",
            "Finitura manico": "vernice naturale all'alcool (poro aperto)",
            "Status": "disponibile"
          }
        }
      }
    ]
  },
  "boom": {
    "title": "boom",
    "description": "Gli strumenti della serie BOOM sono concepiti come delle sculture sonore in cui sperimentazione e ricerca permettono lo sviluppo degli altri modelli Tarazum in commercio. Rappresentano quindi un punto di unione trasversale tra le arti. Scultura, pittura, liuteria, musica e poesia convergono per trasformarsi in manifesti tangibili del pensiero Tarazum.",
    "dataSheet": {
      "Disponibili al pubblico": "NO",
      "Tecnologia Tarazum": "SI",
      "Progettazione Tarazum": "SI",
      "Disegno Tarazum": "SI",
      "Finiture Tarazum": "SI"
    },
    "guitars": [
      {
        "diapason": {
          "title": "diapason",
          "description": "Il modello Diapason di Tarazum rappresenta il primo prototipo realizzato per la messa a punto degli strumenti della serie WOW. Diapason prende spunto dall'esperienza costruttiva degli strumenti di Wandrè. La costruzione è neck-thru body con un manico misto in alluminio ed ebano che termina con due corna a ricordare la forma di un diapason. Al centro vi è l'alloggiamento dell'elettronica concepita come una scatola esagonale che può essere sfilata dal retro dello strumento. Lo strumento è un prototipo e non è disponibile sul mercato. La sua presentazione è però importante per comprendere l'iter evolutivo di studio e messa a punto degli strumenti a marchio Tarazum. Ogni parte è attentamente studiata e migliorata per ottenere un'esperienza sonora sempre di migliore qualità.",
          "dataSheet": {
            "Serie": "BOOM",
            "Anno": "2016",
            "Costruzione": "neck-through / bolt-on",
            "Manico": "alluminio e ebano",
            "Body": "alluminio e frassino",
            "Tastiera": "palissandro santos",
            "Scala": "24,75''",
            "Radius": "7,25''",
            "Bridge": "pickup tipo Woolworth Top 20 (Robert Smith) - Anni '70",
            "Middle": "-",
            "Neck": "pickup Meazzi anni '70",
            "Regolazioni": "2 interruttori on-off pickup, 1 tono, 1 volume",
            "Meccaniche": "Gotoh Stealth",
            "Finitura body": "gommalacca",
            "Finitura manico": "olio di tung"
          }
        }
      },
      {
        "monoblocco": {
          "title": "monoblocco",
          "description": "Il modello Monoblocco di Tarazum parte da un'idea scultorea di ottenere una chitarra da un unico corpo solido in legno. Pertanto questo strumento non ha soluzione di continuità nelle sue parti: la paletta, il manico, il corpo, la tastiera e il ponte sono ricavati dallo stesso pezzo di legno come se fosse un bassorilievo. Lo strumento monta corde in nylon con una spaziatura di corde da chitarra classica. L'amplificazione è ottenuta mediante un ricettore piezoelettrico posto sotto l'osso del ponticello che viene successivamente pre amplificato da un circuito contenuto all'interno del corpo ed accessibile da uno sportello posto sul retro. Un sound e un'esperienza di suonato unica nel suo genere.",
          "dataSheet": {
            "Serie": "BOOM",
            "Anno": "2015",
            "Costruzione": "pezzo unico",
            "Manico": "frassino termotrattato",
            "Body": "frassino termotrattato",
            "Tastiera": "frassino termotrattato",
            "Scala": "24,75''",
            "Radius": "piatto",
            "Bridge": "Piezo pre amplificato",
            "Middle": "-",
            "Neck": "-",
            "Regolazioni": "1 tono, 1 volume",
            "Meccaniche": "Schertler",
            "Finitura body": "gommalacca",
            "Finitura manico": "gommalacca",
            "Status": "disponibile"
          }
        }
      }
    ]
  },
  "filosofy": {
    "title": "filosofy",
    "description": "Gli strumenti Tarazum sono realizzati esclusivamente con legnami di prima scelta a taglio radiale. La selezione del legno avviene presso fornitori specializzati leader nel settore. Tutti i legni impiegati rispettano i criteri Cites (Convenzione di Washington sul commercio internazionale delle specie di fauna e flora selvatiche minacciate di estinzione) in un'ottica di ecosostenibilità.\nCon la stessa sensibilità, gli scarti derivanti dalla lavorazione dei legni vengono avviati, ove possibile, a riutilizzo, recupero energetico e/o riciclo.\nOgni parte di uno strumento viene accuratamente selezionata da Tarazum direttamente presso i fornitori mediante test di risonanza, verifica della fibra e della stagionatura.\nLa stessa cura viene adottata per la scelta delle componenti meccaniche ed elettroniche. Questo perché l'eccellenza del prodotto viene considerata da Tarazum come caratteristica fondamentale per un buon strumento di liuteria.\nTarazum ha deciso di non adottare nessuna lavorazione tramite CNC (controllo numerico computerizzato) per garantire la genuinità del prodotto ed avere un controllo qualità costante dei materiali durante tutte le fasi della realizzazione di uno strumento.\nE' altresì convinto che la finitura di uno strumento debba il più possibile garantirne le armoniche, il volume ed il sustain. Per questo non vengono impiegate finiture di forte spessore coprenti come la nitro o le vernici poliuretaniche ma soltanto finiture eco-sostenibili, reversibili e naturali legate alla tradizione del legno come vernici all'alcool, gommalacca, olio e cera. Sebbene più delicate delle prime, esse favoriscono la risonanza dello strumento e dichiarano la sua vera natura sotto la pelle (da qui lo slogan quality beyond the surface)."
  },
  "concept": {
    "title": "concept",
    "description": "Tarazum: onomatopea che rappresenta il suono tipico di una fanfara o di una banda.\n\n\"Ogni strumento musicale artigianale ha dei caratteri unici ed irripetibili, come le persone: hanno la propria individualità, il proprio carattere, i propri tratti somatici, la propria voce, i propri pregi e difetti. Possono diventare anime gemelle, migliori amici, puoi invidiarle, possono generare antipatia, possono arrivare persino ad essere odiate. Questo perché ogni persona cerca altre persone affini alla propria sensibilità ed scaccia quelle in cui non si riconosce. Lo strumento musicale artigianale non è per tutti. E' per chi interagendo con lui scopre un legame profondo.\"\n\t\t\t\t\t\t\tPaolo Garzillo (Ideatore)\n\nLa certezza che la bellezza e la qualità di un prodotto derivino dalla sintesi di tradizione, conoscenza, energia, esperienza e rapporti umani fanno del laboratorio Tarazum il luogo dove tali caratteri possano confluire, essere amplificati e diventare progetti sonori. Gli strumenti Tarazum non ammiccano alle mode del mercato e non cercano il grande pubblico. Sono concepiti come essenze uniche, capaci di interagire con la sensibilità del singolo musicista."
  },
  "quality": {
    "title": "quality",
    "description": "Ogni strumento a marchio Tarazum è accompagnato da un certificato di autenticità e una scheda tecnica completa in cui trovere tutte le caratteristiche dello strumento.\nInoltre a partire dal 2025, ogni strumento Tarazum è dotato di un sensore NFC (Near Field Communication). Tramite l'impiego di un comune smartphone, è pertanto possibile essere indirizzati direttamente sulla pagina anagrafica di uno specifico strumento tramite il sito Tarazum."
  },
  "biography": {
    "title": "biography",
    "description": "Tarazum nasce da un'idea di Paolo Garzillo (Milano, 1982), architetto, artista, musicista e artigiano italiano. Vive a Seregno ed opera presso Meda.\nDopo essersi diplomato presso l'Istituto Statale D'Arte di Giussano, consegue la laurea in Architettura al Politecnico di Milano. Conosce e frequenta l'atelier dell'architetto Bruno Vaerini, grazie al quale ha l'opportunità di poter sviluppare un preciso pensiero poetico e progettuale.\nLa sua visione poliedrica lo portano a diversi anni di ricerca e studio artistico negli ambiti dell'architettura, dell'artigianato e della musica. Realizza alcuni progetti di architettura di interni; prende parte, come bassista, al progetto rock alternativo NiCE col quale pubblica due dischi e diversi EP.\nNel 2014 approccia al mondo della liuteria costruendo da autodidatta la sua prima chitarra elettrica (Pinder I).\nNel 2015 incontra e frequenta Willy Davoli e Marco Ballestri, grazie ai quali conosce e si innamora degli strumenti del maestro Antonio Pioli detto Wandrè.\nDal 2018 frequenta il laboratorio di liuteria \"La Stanza delle Arti\" diretto dal maestro di liuteria Emanuele Vocale. Qui ha modo di oggettivare, apprendere e sviluppare le tecniche costruttive della liuteria moderna.\nNel 2020 avvia il laboratorio Tarazum presso lo spazio \"Formicaudio\" di Meda dedicandosi all'ideazione, progettazione e produzione di chitarre e bassi artigianali."
  }
}
